/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DiscussionPromptIcon = /*#__PURE__*/ createSvgIcon(
  'DiscussionPromptIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM.5 8a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z" />
            <path d="M6.268 4.818a.81.81 0 00-.878.835V11.393L6.948 9.79h3.542l.021.002a.81.81 0 00.878-.835V5.653a.81.81 0 00-.878-.835l-.02.002H6.288l-.021-.002zm.061-.998A1.81 1.81 0 004.39 5.678v5.682a1 1 0 001.7.747l1.281-1.317h3.08a1.81 1.81 0 001.939-1.858V5.678a1.81 1.81 0 00-1.94-1.858H6.33z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M10 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM.5 10a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z" />
            <path d="M7.788 5.758A1.19 1.19 0 006.5 6.983v7.363a.15.15 0 00.25.117l1.969-2.023h4.474l.022.002a1.178 1.178 0 001.285-1.215V6.983a1.19 1.19 0 00-1.288-1.225l-.021.002H7.809l-.02-.002zm.062-.998A2.19 2.19 0 005.5 7.008v7.315a1.15 1.15 0 001.946.857l.006-.005 1.69-1.735h4.007a2.182 2.182 0 002.351-2.238V7.008a2.19 2.19 0 00-2.35-2.248h-5.3z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g
            clipPath={`url(#${id}_0)`}
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
          >
            <path d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5zM.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12z" />
            <path d="M9.306 6.708A1.56 1.56 0 007.61 8.283V17.311a.29.29 0 00.488.224L10.48 15.1h5.42l.021.002a1.56 1.56 0 001.69-1.606l-.001-.008V8.314a1.56 1.56 0 00-1.688-1.606l-.021.002H9.328l-.022-.002zm.065-.998A2.56 2.56 0 006.61 8.293v8.988a1.29 1.29 0 002.189.968L10.9 16.1h4.96a2.56 2.56 0 002.75-2.628V8.338a2.56 2.56 0 00-2.75-2.628H9.37z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default DiscussionPromptIcon;
